import { Link } from "react-router-dom";

const BreadBanner = ({ bg, title }) => {
  return (
    <section className="page-header" style={{ backgroundImage: `url(${bg})` }}>
      <div className="container">
        <ul className="thm-breadcrumb list-unstyled">
          <li>
            <Link to={"/"}>Home</Link>
          </li>

          <li>
            <span>{title}</span>
          </li>
        </ul>
      </div>
    </section>
  );
};
export default BreadBanner;
